import { Button, Stack, Typography } from "@mui/material";
import React from "react";
import Modal, { CommonModalProps } from "..";
import { useTranslation } from "react-i18next";

export type ModalFileOfflineConfirmAddToBasketElementProps = {
  onConfirm?: () => void;
};

export type ModalFileOfflineConfirmAddToBasketProps = CommonModalProps<ModalFileOfflineConfirmAddToBasketElementProps>;

const ModalFileOfflineConfirmAddToBasket = React.forwardRef<any, ModalFileOfflineConfirmAddToBasketProps>(
  (props, ref) => {
    const { closeModal, onConfirm, ...modalProps } = props;
    const { t } = useTranslation();

    const handleConfirmClick = () => {
      onConfirm && onConfirm();
      closeModal();
    };

    const handleCancelClick = () => {
      closeModal();
    };

    return (
      <Modal
        title={t("modal:title.fileOfflineAddToBasket")}
        reference={ref}
        closeModal={handleCancelClick}
        width={600}
        footer={
          <Stack direction="row" justifyContent="space-between">
            <Button onClick={handleCancelClick}>{t("common:cancel")}</Button>
            <Button color="success" variant="outlined" onClick={handleConfirmClick}>
              {t("common:confirm")}
            </Button>
          </Stack>
        }
      >
        <Typography variant="h6" component="span" color="text.secondary">
          {t("modal:comment.fileOfflineAddToBasket")}
        </Typography>
      </Modal>
    );
  }
);

export default ModalFileOfflineConfirmAddToBasket;
